import styles from "./Payments.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import CopyRight from "../../components/CopyRight/CopyRight";

const taskData = [
  {
    _id: "p1",
    studentName: "John Jacob",
    invoiceId: "INVID088",
    receiptId: "RECID088",
    paymentDate: "2025-05-30",
    paymentMode: "Bank Transfer",
    amount: 2400,
  },
  {
    _id: "p2",
    studentName: "Jane Smith",
    invoiceId: "INVID089",
    receiptId: "RECID089",
    paymentDate: "2025-05-30",
    paymentMode: "Card",
    amount: 3600,
  },
  {
    _id: "p3",
    studentName: "Alex Roy",
    invoiceId: "INVID090",
    receiptId: "RECID090",
    paymentDate: "2025-05-31",
    paymentMode: "UPI",
    amount: 1800,
  },
];
  
  

function Payments() {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const totalAmount = taskData.reduce(
    (sum, item) => sum + (item.amount || 0),
    0
  );


  const getColumnData = (data) => {
    return data.map((item) => ({
      studentName: <LogoWithName name={item.studentName || "-"} />,
      invoiceId: item.invoiceId || "-",
      receiptId: item.receiptId || "-",
      paymentDate: new Date(item.paymentDate).toLocaleDateString("en-GB"),
      paymentMode: item.paymentMode || "-",
      amount: `INR ${item.amount}`,
    }));
  };
  
  

  const displayData = getColumnData(taskData);

  const headingsData = [
    { title: "Student Name", accessor: "studentName" },
    { title: "Invoiced ID", accessor: "invoiceId" },
    { title: "Receipt ID", accessor: "receiptId" },
    { title: "Payment Date", accessor: "paymentDate" },
    { title: "Payment Mode", accessor: "paymentMode" },
    { title: "Amount", accessor: "amount" },
  ];
  

  return (
    <div className={styles.main}>
      <div className={styles.background}>
        <div className={styles.headerContainer}>
          {/* Top Status Boxes */}
          <div className={styles.totalDisplay}>
            Total :{" "}
            <span className={styles.totalAmount}>INR {totalAmount}</span>
          </div>

          {/* Filters & Search */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Student"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.filters}>
                <CalendarInput
                  label="Date"
                  value={selectedDate}
                  onChange={setSelectedDate}
                  background="var(--Utility_Color1)"
                  textColor="gray"
                  iconColor="gray"
                  placeholderColor="gray"
                  borderRadius="25px"
                  shadow={false}
                />
                <Dropdown
                  label="Program"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Group"
                  options={["Group 1", "Group 2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Room"
                  options={["Room1", "Room2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
              </div>
            </div>

            {/* Dynamic Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>

            {/* Pagination */}
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default Payments;
